export default [
    {
      path: '/meeting-and-events',
      name: 'meeting-and-events-read',
      component: () => import('@/views/event/MeetingAndEvents/MeetingAndEventsList.vue'),
      meta: {
        resource: 'Meeting & Events',
        action: 'read',
      },
    },
    {
        path: '/meeting-and-events-icon',
        name: 'meeting-and-events-icon-read',
        component: () => import('@/views/event/MeetingAndEvents/MeetingAndEventsIconList.vue'),
        meta: {
          resource: 'Meeting & Events Icons',
          action: 'read',
        },
    },
  ]